<template>
  <div class="down">
    <div>
      <div class="app-wrap p-center p-wrap">
        <img :src="configFileOnlie.in_icon" class="app-left">
        <div class="app-right">
          <div class="title-name">
            <div class="title-name-one">
              {{configFileOnlie.out_name}}
              <span>{{configFileOnlie.out_kind_ranking}}+</span>
            </div>
            <p>{{$t('message.first')}}</p>
          </div>
          <div class="instal-wrap p-center">
            <div
              v-if="showBtn.install"
              @click="installMobileconfig"
              class="instal-btn j-showBtn j-installBtn"
              style="font-size: 0.373333rem;">
              <span>
                {{$t('message.install_free')}}
              </span>
            </div>
            <div
              v-if="showBtn.disInstall"
              class="instal-btn j-showBtn btn-disable">
              <span class="instal-step-one-two" style="font-size: 0.373333rem;">{{$t('message.android_no_support')}}</span>
            </div>
            <div
              v-if="showBtn.downLoad"
              @click="startDownLoad"
              class="instal-btn j-showBtn j-startDownload"
              style="font-size: 0.373333rem;">
              <span>{{$t('message.start_download')}}</span>
            </div>
            <div
              v-if="showBtn.downLoadFail"
              class="instal-btn j-showBtn j-startDownload"
              style="font-size: 0.373333rem;">
              <span>{{$t('message.down_fail')}}</span>
            </div>
            <div
              v-if="showBtn.downLoadTimeout"
              class="instal-btn j-showBtn j-startDownload"
              style="font-size: 0.373333rem;">
              <span>{{$t('message.start_download')}}</span>
            </div>
            <div
              v-if="showBtn.downloadProgress"
              class="download-progress-out j-download-progress">
              <div class="innder" :style="{width: downloadProgressNum + '%'}"></div>
              <span>{{downloadProgressNum}}%</span>
            </div>
            <div
              v-if="showBtn.installProgress"
              class="instal-btn j-showBtn j-startInstall"
              style="font-size: 0.373333rem;">
              <span v-if="installCoutDownTime > 0">{{$t('message.installing')}}...{{installCoutDownTime}} s</span>
              <span v-else @click="pop.promptAction=true">{{$t('message.over')}}</span>
            </div>
            <div
              v-if="showBtn.installationGuideIcon"
              @click="(pop.installationGuide=true, mySwiperFun())"
              class="instal-ask u-backgroundImage j-showInstallationGuide"></div>
            <div
              v-if="showBtn.reloadIcon"
              @click="reStartDownLoad"
              class="instal-ask u-backgroundImage reload j-reload"></div>
          </div>
          <div
            v-if="!installCoutDownTime"
            class="over-tip">{{$t('message.open_in_itune')}}</div>
        </div>
      </div>
      <div class="p-wrap">
        <div class="brief">
          <div class="brief-top p-center">
            <div class="brief-top-l">
              <div class="brief-top-l-t brief-font-one">
                <span>{{configFileOnlie.out_score}}</span>
                <!-- <span></span> -->
                <div class="star-contain"  id="openBtn12">
                  <div class="bg" :style="{width: configFileOnlie.out_score / 5 * 100 + '%'}"></div>
                  <ul id='xx'>
                    <li v-for="i in 5" :key="i"></li>
                  </ul>
                </div>
              </div>
              <p class="brief-font-two">{{configFileOnlie.out_evaluate_number | evaluate}}{{$t('message.k_score')}}</p>
            </div>
            <div class="brief-top-c">
              <div class="brief-top-l-c brief-font-one">
                <span class="sb">#</span>
                <span>{{configFileOnlie.out_kind_ranking}}</span>
              </div>
              <p class="brief-font-two">{{configFileOnlie.out_app_kind}}</p>
            </div>
            <div class="brief-top-r">
              <div class="brief-top-l-r brief-font-one">{{configFileOnlie.out_age_limit}}+</div>
              <p class="brief-font-two">{{$t('message.age')}}</p>
            </div>
          </div>
          <div class="brief-des" v-if="configFileOnlie.out_guide_link&&(lang == 'zh')">
            <p class="public-title-big" >{{$t('message.install_introduce')}}</p>
            <div class="video-contain">
              <!-- <video
                controls
                class="install-teach-video"
                :src="configFileOnlie.out_guide_link"
                :poster="configFileOnlie.out_guide_pic_link"></video> -->
              <video-player
                class="install-teach-video video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"></video-player>
              <p class="text">{{configFileOnlie.out_name}}{{$t('message.appal_video_guild')}}</p>
            </div>
          </div>
          <div class="brief-des">
            <p class="public-title-big" @click="phoneTest.clickCode.push(1)">{{$t('message.intro')}}</p>
            <div class="btn-box to-main-site">
              <div class="simple-install-btn" v-if="sid" @click="$router.push('/line?sid='+sid)">
                <span>多节点</span>
              </div>
              <!-- class to-main-site 定位 -->
              <div class="simple-install-btn " v-if="configFileOnlie.out_app_website" @click="toMainSite">
                <span>{{$t('message.to_main_site')}}</span>
              </div>
            </div>
            <div class="brief-des-block">
              <div class="brief-des-block-wrap">
                <div class="brief-des-msg" v-html="configFileOnlie.out_intro"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-wrap p-border">
        <div class="score">
          <p class="public-title-big" @click="phoneTest.clickCode.push(2)">{{$t('message.score_and_post')}}</p>
          <div class="scrop-left">
            <p class="scrop-left-t">{{configFileOnlie.out_score}}</p>
            <p class="scrop-left-b">{{$t('message.fullscore')}}</p>
          </div>
          <div class="scrop-right">
            <div class="scrop-r-start">
              <div>
                <span class="start-5 start-p"></span>
                <div class="start-line-wrap">
                  <div class="start-line" :style="{width: 19 * configFileOnlie.out_score + '%'}"></div>
                </div>
              </div>
              <div>
                <span class="start-4 start-p"></span>
                <div class="start-line-wrap">
                  <div class="start-line" :style="{width: 5 * configFileOnlie.out_score + '%'}"></div>
                </div>
              </div>
              <div>
                <span class="start-3 start-p"></span>
                <div class="start-line-wrap">
                  <div class="start-line" :style="{width: 2 * configFileOnlie.out_score + '%'}"></div>
                </div>
              </div>
              <div>
                <span class="start-2 start-p"></span>
                <div class="start-line-wrap">
                  <div class="start-line" :style="{width: 1 * configFileOnlie.out_score + '%'}"></div>
                </div>
              </div>
              <div>
                <span class="start-1 start-p"></span>
                <div class="start-line-wrap">
                  <div class="start-line" :style="{width: .5 * configFileOnlie.out_score + '%'}"></div>
                </div>
              </div>
            </div>
            <p class="start-r-num">{{configFileOnlie.out_evaluate_number | evaluate}}{{$t('message.k_score')}}</p>
          </div>
        </div>
      </div>
      <div class="p-wrap p-border">
        <div class="new-version">
          <p class="public-title-big" @click="phoneTest.clickCode.push(3)">{{$t('message.new_fun')}}</p>
          <div class="public-title-version" v-show="configFileOnlie.in_bsvs">版本 {{configFileOnlie.in_bsvs}}</div>
          <div class="version-1">
            <p class="version-msg">
                {{configFileOnlie.out_new_feature}}</p>
          </div>
        </div>
      </div>
      <div class="p-wrap p-border">
        <div class="more-msg">
          <p class="public-title-big" @click="phoneTest.clickCode.push(4)">{{$t('message.info')}}</p>
          <div class="msg-list-wrap">
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.distributor')}}</p>
              <p class="msg-list-r">{{configFileOnlie.out_distributor}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.size')}}</p>
              <p class="msg-list-r">{{configFileOnlie.in_size}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.kind')}}</p>
              <p class="msg-list-r msg-color1">{{configFileOnlie.out_app_kind}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.compatible')}}</p>
              <p class="msg-list-r">{{$t('message.versionleft')}}{{configFileOnlie.in_mnvs}}{{$t('message.versionright')}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.lang')}}</p>
              <p class="msg-list-r">
                <i class="randomcode">{{configFileOnlie.out_langs}}</i>
              </p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.age_limit')}}</p>
              <p class="msg-list-r">{{$t('message.ageleft')}}{{configFileOnlie.out_age_limit}}{{$t('message.ageright')}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">Copyright</p>
              <p class="msg-list-r">{{configFileOnlie.out_copyright}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.price')}}</p>
              <p class="msg-list-r">{{configFileOnlie.out_app_price}}</p>
            </div>
            <div class="msg-list">
              <p class="msg-list-l">{{$t('message.policy_privay')}}</p>
              <p class="msg-list-r">
                <i class="support u-backgroundImage"></i>
              </p>
            </div>
            <div class="msg-list" v-if="randomCode">
              <p class="msg-list-l">{{$t('message.randomCode')}}</p>
              <p class="msg-list-r"
                v-clipboard:copy="randomCode"
                v-clipboard:success="$parent.onSuccessCopyRandomCode"
                v-clipboard:error="$parent.onErrorCopyRandomCode">
                <i class="randomcode">{{randomCode}}</i>
              </p>
            </div>
            <div class="msg-list" v-if="configFileOnlie.out_old_install && udid" @click="showOldVersionList">
              <p class="msg-list-l">{{$t('message.previous_version')}}</p>
              <p class="msg-list-r">
                <img src="../assets/images/IndexImages/angle-right.svg" class="arrow-right">
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="eta">
        <p>{{$t('message.disclaimer')}}：</p>
        <p>{{$t('message.disclaimer_detail')}}</p>
      </div>
    </div>

    <!-- 微信中打开 -->
    <div v-if="pop.wechatMask" class="wechat j-wechat u-pop">
      <ul class="texts">
        <li class="title">{{$t('message.step1')}}</li>
        <li>
          {{$t('message.click_coner')}}
          <i class="u-icon more"></i>{{$t('message.button')}}
        </li>
        <li class="title">{{$t('message.step2')}}</li>
        <li>{{$t('message.open_IE')}}</li>
      </ul>
      <i class="pointToTop"></i>
      <i class="pointToBottom"></i>
      <img src="../assets/images/IndexImages/showBottom.png" class="showBottom">
    </div>

    <!-- 其它浏览器打开 -->
    <div v-if="pop.otherBrowserMask" class="otherBrowser j-otherBrowser u-pop">
      <ul class="texts">
        <li class="title">{{$t('message.step1')}}</li>
        <li>{{$t('message.click_copy')}}</li>
        <li class="title">{{$t('message.step2')}}</li>
        <li>{{$t('message.open_IE')}}</li>
      </ul>
      <i class="pointToTop"></i>
      <i class="pointToBottom"></i>
      <img src="../assets/images/IndexImages/showBottomOtherBrowser.png" class="showBottom">
    </div>

    <!-- 安装指引 -->
    <transition name="fade">
      <div v-show="pop.installationGuide" class="u-pop installationGuide j-installationGuide">
        <div class="contain">
          <img
            @click="pop.installationGuide=false"
            src="data:image/png;base64,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"
            class="step-close j-installationGuide-close">
          <div class="what j-showDescribe" :class="[isIos16 && 'left']" @click="pop.describeFile=true">{{$t('message.guild_title')}}</div>
          <div class="what j-showDescribe" v-if="isIos16" :class="[isIos16 && 'isIos16']" @click="pop.ios16=true">{{$t('message.guild_title_1')}}</div>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img :src='"../assets/images/IndexImages/installGuild/"+ lang +"/installationGuide01.png"'>
                <div class="swipe-tip">
                  <p class="font18">{{$t('message.guild')}}</p>
                  <p class="font15">{{$t('message.guild_step1')}}</p>
                </div>
              </div>
              <div class="swiper-slide">
                <img  :src='"../assets/images/IndexImages/installGuild/"+ lang +"/installationGuide02.png"'>
                <div class="swipe-tip">
                  <p class="font18">{{$t('message.guild')}}</p>
                  <p class="font15">{{$t('message.guild_step2')}}</p>
                </div>
              </div>
              <div class="swiper-slide">
                <img  :src='"../assets/images/IndexImages/installGuild/"+ lang +"/installationGuide03.png"'>
                <div class="swipe-tip">
                  <p class="font18">{{$t('message.guild')}}</p>
                  <p class="font15">{{$t('message.guild_step3')}}</p>
                </div>
              </div>
              <div class="swiper-slide">
                <img  :src='"../assets/images/IndexImages/installGuild/"+ lang +"/installationGuide04.png"'>
                <div class="swipe-tip">
                  <p class="font18">{{$t('message.guild')}}</p>
                  <p class="font15">{{$t('message.guild_step4')}}</p>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 描述文件 -->
    <transition name="fade">
      <div v-show="pop.describeFile" class="u-pop describe j-describe">
        <div class="des-wrap">
          <div class="wenzi-wrap">
            <p class="des-title">{{$t('message.desc')}}</p>
            <p class="explain-title">{{$t('message.desc_why_install')}}</p>
            <p class="explain-desc">{{$t('message.desc_reson')}}</p>
            <p class="explain-title">{{$t('message.desc_explain_title')}}</p>
            <p class="explain-desc">{{$t('message.desc_explain_desc')}}</p>
            <p class="explain-title">{{$t('message.desc_why_password')}}</p>
            <p class="explain-desc">{{$t('message.desc_psw_reson')}}</p>
          </div>
          <div class="operation-btn j-describeClose" @click="pop.describeFile=false">{{$t('message.desc_know')}}</div>
        </div>
      </div>
    </transition>

    <!-- 描述文件 -->
    <transition name="fade">
      <div v-show="pop.ios16" class="u-pop describe j-describe">
        <div class="des-wrap">
          <div class="pop-title">如遇到图一提示,请参照图二开启开发者模式</div>
          <div class="wenzi-wrap">
            <img src="../assets/images/IndexImages/bg-1.png" alt="" srcset="">
            <img src="../assets/images/IndexImages/iOS16.jpg" :alt="$t('message.guild_title_1')">
          </div>
          <div class="operation-btn j-describeClose" @click="pop.ios16=false">{{$t('message.desc_know')}}</div>
        </div>
      </div>
    </transition>

    <!-- 点完成按钮后的弹窗提示 -->
    <transition name="fade">
      <div v-show="pop.promptAction" @click="pop.promptAction=false" class="u-pop suceess-button-tips finished">
        <div class="contain" @click.stop>
          <p>{{$t('message.back_detail')}}</p>
          <p class="content mid" v-if="isIos16">{{$t('message.ios16Tip1')}}</p>
          <p class="content"  v-if="isIos16">{{$t('message.ios16Tip2')}}</p>
        </div>
      </div>
    </transition>

    <!-- 提示用户今天不能下载，请明天再试 -->
    <transition name="fade">
      <div v-show="pop.reachInstallLimit" @click="pop.reachInstallLimit=false" class="u-pop suceess-button-tips">
        <div class="contain" @click.stop>
          <p>{{$t('message.outof_limit')}}</p>
        </div>
      </div>
    </transition>

    <!-- ios17 描述文件 -->
    <transition name="fade">
      <div v-show="pop.ios17" class="u-pop describe j-describe">
        <div class="des-wrap">
          <p class="des-title">{{$t('message.提示')}}</p>
          <div class="wenzi-wrap">
            由于 ios17 系统限制，请手动在手机
            <!-- <br> -->
            <b class="text-017afe" >【设置】</b>-<b class="text-017afe" >已下载描述文件</b>
            <!-- <br> -->
            或 <b class="text-017afe">【设置】</b>-<b class="text-017afe">【通用】</b>-<b class="text-017afe">【设备管理】</b>-找到已下载的描述文件（点击安装后进行下一步）
          </div>
          <div class="lanSe-btn" @click="pop.ios17=false">{{$t('message.我已知晓')}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from "Vuex";
  import "@/assets/css/index.css";
  import "@/assets/js/flexible";
  import Swiper from "@/assets/js/swiper.min";
  import axios from "axios";
  import { hexMd5 } from "@/api/md5";
  import VConsole from "@/api/vconsole.min";
  // import axios from "@/api/request.js";
  export default {
    name: "Index",
    data() {
      return {
        hasMode: false,
        showBtn: {
          // 所有按钮
          install: false, // 安装按钮
          disInstall: false, // 安卓下不能安装按钮
          downLoad: false, // 下载按钮
          downLoadFail: false, // 下载失败按钮
          downloadProgress: false, // 下载进度条按钮
          installProgress: false, // 安装进度条按钮
          installationGuideIcon: true, // 指导icon
          reloadIcon: false, // 重新下载icon
        },
        pop: {
          // 所有弹窗
          wechatMask: false, // 微信下弹窗
          otherBrowserMask: false, // 其它浏览器弹窗
          installationGuide: false, // 安装指引
          describeFile: false, // 描述文件
          promptAction: false, // 点击完成按钮后弹出提示操作弹窗
          reachInstallLimit: false, // 今天达到安装数量上限
          ios16: false, // ios16下提示用户开启开发者模式
          ios17:false
        },
        mySwiper: "",
        downloadProgressNum: 0, // 下载进度百分比
        installCoutDownTime: 10, // 安装进度倒计时
        apiUrl: "",
        apiKey: "",
        udid: "",
        randomCode: "",
        appCode: "",
        configFileOnlie: "",
        timerInerval: "",
        controller: false, // 用来标识下载接口是否正确返回
        promptActionTimer: "", // 完成按钮弹窗的频繁点击控制
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "",
              src: "", // url地址
            },
          ],
          poster: "", // 你的封面地址
          notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: true, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            fullscreenToggle: true, // 全屏按钮
          },
        },
        phoneTest: {
          // 为真机环境可测试挂载的彩蛋变量（当clickCode与isTestCode值一致时触发彩蛋，弹出Vconsole调试插件）
          isTestCode: [2, 3, 4, 4, 3, 2],
          clickCode: [],
        },
        autoStartDownload: true, // 是否获取到udid信息后自动开始下载
        downProccessOver: false, // 是否正在下载
        toOldProgress: false,
        sign_success: false,
        lang: "zh",
        langId: "",
        sid:"", //649
      };
    },
    watch: {
      $route() {
        this.$route.name === "/Index" && location.reload();
        console.log(this.$route.name, "------route-name-listen");
        this.$route.name === "/multiIndex" && location.reload();
      },
      // lang(newv, oldv) {
      //   this.$i18n.locale = newv.value;
      //   window.sessionStorage.setItem("lang", JSON.stringify(newv));
      //   // quasar组件中英文
      //   let lang;
      //   if (newv.value == "zh") {
      //     lang = "zh-hans";
      //   }
      //   if (newv.value == "en") {
      //     lang = "en-us";
      //   }
      //   // 这里用到了quasar的组件, 引入他们家的组件语言包
      //   import(`quasar/lang/${lang}`).then(res => {
      //     this.$q.lang.set(res.default);
      //   });
      // },
      pop: {
        // 深度监听pop弹窗
        handler(newVaule, oldVaule) {
          // if (newVaule.promptAction) { // 如果打开提示弹窗，则两秒后再关闭
          //   this.promptActionTimer && clearTimeout(this.promptActionTimer)
          //   this.promptActionTimer = setTimeout(() => {
          //     this.pop.promptAction = false
          //   }, 2000)
          // }
        },
        deep: true,
      },
      phoneTest: {
        // 深度监听彩蛋
        handler(newVaule, oldVaule) {
          if (newVaule.isTestCode.join("") === newVaule.clickCode.join("")) {
            // 判定值一致
            document.querySelector("#__vconsole").style.display = "block";
          }
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters({}),
      isIos16() {
        const str = navigator.userAgent.toLowerCase();
        const ver = str.match(/cpu iphone os (.*?) like mac os/);
        if (ver) {
          const versionMain = ver[1].split("_")[0]; // 主版本
          return +versionMain >= 16;
        }
      },
      isIos17(){
        const str = navigator.userAgent.toLowerCase();
        const ver = str.match(/cpu iphone os (.*?) like mac os/);
        if (ver) {
          const versionMain = ver[1].split("_")[0]; // 主版本
          return +versionMain >= 17;
        }
      },
    },
    filters: {
      evaluate(val) {
        return val ? Math.round(val / 1000) : "";
      },
    },
    components: {},
    mounted() {

      this.getLan();
      const _this = this;
      this.getMode();
      this.apiKey = window.yunweiConfig.apiKey; // 获取apiKey用来获取app下载地址时做加密
      this.appCode = this.$route.query.appCode; // appCode用来标识下载的app为哪个产品的哪个app，必须要传入
      this.$store.state.appCode = this.appCode
      this.udid = this.$route.query.UDID || this.getUdid(); // 有udid表示下载页，无表示免费安装配置文件页
      this.randomCode = this.$route.query.randomCode || this.getRandomCode(); // 有randomCode表示下载页，无表示免费安装配置文件页
      this.getConfigFileOnline(function () {
        // 获取在线配置文件
        _this.initBtn(); // 初始化按钮
        _this.envFun(); // 根据当前运行环境展示不同firstStep，真机环境+浏览器
        if (
          _this.randomCode &&
          _this.randomCode != "undefined" &&
          _this.autoStartDownload
        ) {
          _this.udid && _this.startDownLoad(); // 有udid则自动开始下载
        }
      });
      this.$route.query.UDID && this.saveUdid(); // 带入udid的话，则存起来，下次再进入描述页则可直接进行安装
      this.udid ||
        this.setCookie(
          "param",
          "",
          document.domain.split(".").slice(-2).join("."),
          new Date(0)
        ); // 描述页进入或刷新则清除掉cookie（渠道包功能）
      this.$route.query &&
        (this.$route.query.agentId || this.$route.query.signParam) &&
        this.setCookie(
          "param",
          Object.keys(this.$route.query)
            .map((item) => item + "=" + this.$route.query[item])
            .join("&"),
          document.domain.split(".").slice(-2).join(".")
        ); // 无cookie则设定cookie，有cookie则不执行（渠道包功能）
      if (!this.appCode) throw new Error("appCode为必传参数");
      // const VConsoleObj = new VConsole();
    },
    methods: {
      toMainSite() {
        window.open(this.configFileOnlie.out_app_website, "_blank");
        // location.href = this.configFileOnlie.out_app_website
      },
      showOldVersionList() {
        this.$router.push({
          path: "/oldVersionList",
          query: { appCode: this.appCode },
        });
      },
      getMode() {
        this.hasMode = this.$route.query.appCode && this.$route.query.model;
        return this.hasMode;
      },
      getLan() {
        console.log("------getlan");
        let locale_lan = this.$route.query.appCode && this.$route.query.lang;
        switch (locale_lan) {
          case "en":
            this.lang = "en";
            this.$i18n.locale = "en";
            this.langId = 1;
            this.saveLang();
            break;
          case "cn":
            this.lang = "zh";
            this.$i18n.locale = "zh";
            this.langId = 0;
            this.saveLang();
            break;
          case "th":
            this.lang = "tl";
            this.$i18n.locale = "tl";
            this.langId = 9;
            this.saveLang();
            break;
          case "ja":
            this.lang = "jp";
            this.$i18n.locale = "jp";
            this.langId = 3;
            this.saveLang();
            break;
          case "vi":
            this.lang = "vn";
            this.$i18n.locale = "vn";
            this.langId = 10;
            this.saveLang();
            break;
          default:
            this.getDefaultLang();
        }
      },
      getDefaultLang() {
        console.log("------getlan-defalt");
        let lmap = {
          en: 1,
          zh: 0,
          tl: 9,
          jp: 3,
          vn: 10,
        };
        if (this.getLang()) {
          this.lang = this.getLang();
          this.$i18n.locale = this.getLang();
          if (lmap[this.lang] || this.lang == "zh") {
            this.langId = lmap[this.lang];
            console.log(
              this.lang,
              this.langId,
              lmap[this.lang],
              "------------lang-from-local"
            );
          }
          return;
        }
        this.lang = "zh";
        this.$i18n.locale = "zh";
        this.langId = "";
      },
      toinstallindex() {
        location.href = location.origin + "/#/tabSignIndex2020";
        // this.$router.push('/tabSignIndex2020')
      },
      saveUdid() {
        // 缓存udid
        try {
          localStorage.setItem("udid", this.udid);
          localStorage.setItem("randomCode", this.$route.query.randomCode);
        } catch (e) {
          this.setCookie(
            "udid",
            this.udid,
            document.domain.split(".").slice(-2).join(".")
          );
          this.setCookie(
            "randomCode",
            this.$route.query.randomCode,
            document.domain.split(".").slice(-2).join(".")
          );
        }
      },
      getUdid() {
        // 获取udid
        try {
          return localStorage.getItem("udid");
        } catch (e) {
          return this.getCookie("udid");
        }
      },
      saveLang() {
        // 缓存lang
        try {
          localStorage.setItem("lang", this.lang);
        } catch (e) {
          this.setCookie(
            "lang",
            this.lang,
            document.domain.split(".").slice(-2).join(".")
          );
        }
      },
      getLang() {
        // 获取lang
        try {
          return localStorage.getItem("lang");
        } catch (e) {
          return this.getCookie("lang");
        }
      },
      getRandomCode() {
        // 获取randomCode
        try {
          return localStorage.getItem("randomCode");
        } catch (e) {
          return this.getCookie("randomCode");
        }
      },
      setCookie(name, data, domain, expires) {
        localStorage.setItem(name,data) 
        // 设定cookie
        document.cookie =
          name +
          "=" +
          data +
          ";domain=" +
          domain +
          (expires ? ";expires=" + expires.toUTCString() : "");
      },
      getCookie(name) {
        // 获取cookie
        const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        let val = reg.test(document.cookie) ? document.cookie.match(reg)[2] : null;
        if(val){
            return val
        }
        return localStorage.getItem(name) || null
    },
      random(min, max) {
        // 获取最小到最大值间的随机数，并保留两位小数
        return Math.random() * (max - min) + min;
      },
      envFun() {
        // 根据当前运行环境展示不同信息，真机环境+浏览器
        if (this.whatEnv().isWechat()) {
          this.pop.wechatMask = true;
        } else if (this.whatEnv().android()) {
          this.showBtn.install = false;
          this.showBtn.disInstall = true;
        } else if (!this.whatEnv().isSafari()) {
          this.pop.otherBrowserMask = true;
        }
      },
      initBtn() {
        // 初始化按钮
        if (!this.udid) {
          // 有udid表示下载页，无表示免费安装配置文件页
          this.showBtn.install = true;
        } else {
          this.showBtn.downLoad = true;
        }
      },
      mySwiperFun() {
        // 挂载swiper
        const _this = this;
        if (!this.mySwiper) {
          setTimeout(function () {
            _this.mySwiper = new Swiper(".swiper-container", {
              autoplay: 50000, // 可选选项，自动滑动
              loop: true, // 可选选项，开启循环
              paginationClickable: true,
              pagination: ".swiper-pagination",
            });
          }, 100);
        }
      },
      installMobileconfig() {
        // 点击免费安装按钮
        const _this = this;
        // this.downloadFile('./static/file/1.mobileconfig?v=200')
        this.downloadFile(this.configFileOnlie.description_file);
        if(this.isIos17){
          this.pop.ios17 = true
          return
        }
        setTimeout(function () {
          _this.downloadFile("./static/file/validFile.mobileprovision");
        }, 3000);
      },
      downloadFile(src) {
        // 下载文件
        const [x, y] = [
          src.lastIndexOf("/"),
          src.indexOf("?") !== -1 ? src.indexOf("?") : src.length,
        ];
        const a = document.createElement("a");
        a.href = src;
        a.download = src.slice(x + 1, y);
        a.click();
      },
      whatEnv() {
        // 判断当前运行环境
        const userAgent = navigator.userAgent;
        return {
          android() {
            return userAgent.match(/Android/i);
          },
          ios() {
            return userAgent.match(/iPhone|iPad|iPod/i);
          },
          isSafari() {
            // 是不是safari浏览器
            return (
              /safari/gi.test(userAgent) &&
              !/(crios|chrome|fxios|qqbrowser|sogou|baidu|ucbrowser|qhbrowser|opera|micromessenger|weibo)/gi.test(
                userAgent
              )
            );
          },
          isWechat() {
            return /MicroMessenger/i.test(userAgent) || /_SQ_/i.test(userAgent);
          },
        };
      },
      downloadProgressf(task_id, download_url) {
        // 下载进度动画
        console.log(task_id, download_url, "id -----url");
        // 每隔3000ms调一次
        this.downProccessOver = true;
        const [_this, timer] = [this, 6000]; // A02包比较大，做兼容
        this.timerInerval && clearInterval(this.timerInerval);
        let count = 0;
        this.timerInerval = setInterval(function () {
          if (!_this.sign_success && !download_url) {
            if (count % 2 == 0) {
              _this.getStep(task_id);
            } else {
              _this.getStep();
            }
            count++;
            // if(count == 99) {
            //   _this.getStep(task_id, 1)
            // }
            if (count > 100) {
              _this.timerInerval && clearInterval(_this.timerInerval);
              count = 0;
              this.downProccessOver = false;
            }
          }
          console.log(_this.downloadProgressNum, "_this.downloadProgressNum");
          // _this.controller || (_this.downloadProgressNum > 99 && (_this.downloadProgressNum = 99))
          if (_this.downloadProgressNum == 100 || download_url) {
            _this.timerInerval && clearInterval(_this.timerInerval);
            _this.installProgress();
            count = 0;
          }
        }, timer);
      },
      downloadProgress() {
        // 下载进度动画
        // 每隔500ms增加1~6%的进度条
        const [_this, timer] = [this, 500]; // A02包比较大，做兼容
        const maxNum =
          100 /
          this.configFileOnlie.out_download_keep_second /
          (1000 / timer / 2); // 每timer毫秒跑动进度的最大值
        this.timerInerval && clearInterval(this.timerInerval);
        this.timerInerval = setInterval(function () {
          _this.downloadProgressNum = parseFloat(
            +_this.downloadProgressNum + _this.random(0, maxNum)
          ).toFixed(2);
          _this.controller ||
            (_this.downloadProgressNum > 99 && (_this.downloadProgressNum = 99));
          if (_this.downloadProgressNum > 100) {
            _this.timerInerval && clearInterval(_this.timerInerval);
            _this.downloadProgressNum = 100;
            _this.installProgress();

          }
        }, timer);
      },
      startDownLoad1() {
        console.log(2)
        // 获取app下载地址，开始打包下载app
        const _this = this;
        const [apiKey, appCode, appVersion] = [
          this.apiKey,
          this.appCode,
          this.configFileOnlie.in_bsvs,
        ];
        const apiSign = hexMd5(appCode + ":" + appVersion + ":" + apiKey);
        this.showBtn.reloadIcon = false;
        this.showBtn.downLoad = false;
        this.showBtn.downloadProgress = true;
        this.downloadProgress(); // 开始走下载进度条
        const [data, param] = [{}, this.getCookie("param")];
        param &&
          param.split("&").forEach((item) => {
            const index = item.indexOf("=");
            data[item.slice(0, index)] = item.slice(index + 1);
          });
        Object.assign(data, { udid: this.udid });
        data.model = this.hasMode || 0;
        if (this.langId == 0) {
          data.lang = 0;
        } else if (this.langId) {
          data.lang = this.langId;
        } else {
          data.lang = "";
        }
        console.log('data',data)
        axios({
          method: "POST",
          url: "/api/sign/firstStep",
          timeout: this.configFileOnlie.out_download_keep_second * 1000, // 根据接口返回字段配置接口超时时长
          data: data,
          headers: {
            "X-Api-Sign": apiSign,
            appCode,
            appVersion,
          },
        })
          .then(function (res) {
            console.log(res, "old-first-step");
            if (res.data && res.data.body && res.data.body.success === 1) {
              _this.controller = true;
              _this.downloadFile(res.data.body.data.download_url);
            } else {
              _this.timerInerval && clearInterval(_this.timerInerval);
              _this.showBtn.downLoadFail = true;
              _this.showBtn.downloadProgress = false;
              _this.showBtn.installProgress = false;
              _this.showBtn.reloadIcon = true;
              res.data.head.errCode === "ADS_4041002" &&
                (_this.pop.reachInstallLimit = true); // 今日安装达到上限
              res.data.body && res.data.body.msg;
              if (
                res.data.body &&
                res.data.body &&
                res.data.body.msg === "UDID信息不正确"
              ) {
                _this.resetDowloadUrl();
              } else {
                alert(res.data.body.msg);
                //alert(_this.$t('message.error1'))
              }
            }
          })
          .catch(function (error) {
            _this.timerInerval && clearInterval(_this.timerInerval);
            _this.showBtn.downLoadTimeout = true;
            _this.showBtn.downloadProgress = false;
            _this.showBtn.installProgress = false;
            _this.showBtn.reloadIcon = true;
            console.log(error);
          });
      },
      startDownLoad() {
        // 获取app下载地址，开始打包下载app
        if (!this.toOldProgress) {
          this.startDownLoad1();
          return;
        }
        const _this = this;
        const [apiKey, appCode, appVersion] = [
          this.apiKey,
          this.appCode,
          this.configFileOnlie.in_bsvs,
        ];
        const apiSign = hexMd5(appCode + ":" + appVersion + ":" + apiKey);
        this.showBtn.reloadIcon = false;
        this.showBtn.downLoad = false;
        this.showBtn.downloadProgress = true;
        const [data, param] = [{}, this.getCookie("param")];
        param &&
          param.split("&").forEach((item) => {
            const index = item.indexOf("=");
            data[item.slice(0, index)] = item.slice(index + 1);
          });
        Object.assign(data, { udid: this.udid });
        console.log(data, "data-start");
        data.model = this.hasMode || 0;
        if (this.langId == 0) {
          data.lang = 0;
        } else if (this.langId) {
          data.lang = this.langId;
        } else {
          data.lang = "";
        }
        axios({
          method: "POST",
          url: "/api/sign/firstNewStep",
          timeout: this.configFileOnlie.out_download_keep_second * 1000, // 根据接口返回字段配置接口超时时长
          data: data,
          headers: {
            "X-Api-Sign": apiSign,
            appCode,
            appVersion,
          },
        })
          .then(function (res) {
            console.log(res, "new-first-step");
            // let canSign = (res.data && res.data.body && res.data.body.success === 1)
            if(res.data && res.data.body && res.data.body.success==1){
              _this.sid = res.data.body.data.sid
            }
            let canSign =
              res.data && res.data.body && res.data.body.success === 1;
            let download_url =
              res.data &&
              res.data.body &&
              res.data.body.success === 1 &&
              res.data.body.data &&
              res.data.body.data.download_url;
            let task_id =
              res.data &&
              res.data.body &&
              res.data.body.success === 1 &&
              res.data.body.data &&
              res.data.body.data.task_id;
            console.log(
              canSign,
              res.data.body &&
                res.data.body.data &&
                res.data.body.data.download_url,
              "cansign"
            );
            if (canSign) {
              console.log("----开始进度");
              // task_id = 'public:supersign_adhoc_sign:ae2d95fc575359932d4353d920b6e01f'
              if (download_url) {
                console.log("----已经签名");
                _this.controller = true;
                _this.downloadFile(res.data.body.data.download_url);
                _this.downloadProgressNum = 100;
                _this.installProgress();
              } else {
                _this.downloadProgressf(task_id, download_url); // 开始走下载进度条
              }
            } else {
              console.log(res.data.body.msg, "no-sign-msg");
              alert(res.data.body.msg); //

              //需要区分进行中 和 失败
              //alert(_this.$t('message.error1'))
            }
          })
          .catch((error) => {
            console.log(error, "start-err");
          });
      },
      getStep(task_id, is_task_end) {
        const [apiKey, appCode, appVersion] = [
          this.apiKey,
          this.appCode,
          this.configFileOnlie.in_bsvs,
        ];
        const [data, param] = [{}, this.getCookie("param")];
        const apiSign = hexMd5(appCode + ":" + appVersion + ":" + apiKey);
        Object.assign(data, { udid: this.udid }, { task_id: task_id });
        let _this = this;
        if (is_task_end) {
          data.is_task_end = 1;
        }
        data.model = this.hasMode || 0;
        if (this.langId == 0) {
          data.lang = 0;
        } else if (this.langId) {
          data.lang = this.langId;
        } else {
          data.lang = "";
        }
        data.last_progress = this.downloadProgressNum || 0;
        axios({
          method: "POST",
          url: "/api/sign/getProgressStep",
          timeout: this.configFileOnlie.out_download_keep_second * 1000, // 根据接口返回字段配置接口超时时长
          data: data,
          headers: {
            "X-Api-Sign": apiSign,
            appCode,
            appVersion,
          },
        })
          .then(function (res) {
            console.log(
              res,
              res.data.body.data && res.data.body.data.current_progress,
              "2-step"
            );
            _this.downloadProgressNum =
              (res.data.body.data && res.data.body.data.current_progress) || 0; // 进度
            _this.downloadProgressNum = parseInt(_this.downloadProgressNum);
            console.log(_this.downloadProgressNum, "downloadProgressNum ");
            let sign_success =
              res.data &&
              res.data.body &&
              res.data.body.data &&
              res.data.body.data.current_progress === 100 &&
              res.data.body.data.download_url;
            console.log(sign_success, "sign-success");
            _this.sign_success = sign_success;
            let continueStep =
              res.data &&
              res.data.body &&
              res.data.body.data &&
              res.data.body.data.current_progress < 100;
            if (continueStep) {
              return;
            }
            if (sign_success) {
              _this.sid = res.data.body.data.sid
              console.log(
                res.data.body.data && res.data.body.data.download_url,
                "res.data.body.download_url"
              );
              _this.controller = true;
              _this.downloadFile(res.data.body.data.download_url);
              _this.downloadProgress = false;
            } else {
              _this.timerInerval && clearInterval(_this.timerInerval);
              _this.showBtn.downLoadFail = true;
              _this.showBtn.downloadProgress = false;
              _this.showBtn.installProgress = false;
              _this.showBtn.reloadIcon = true;
              res.data.head.errCode === "ADS_4041002" &&
                (_this.pop.reachInstallLimit = true); // 今日安装达到上限
              _this.downloadProgress = false;
              if (
                res.data.body &&
                res.data.body &&
                res.data.body.msg === "UDID信息不正确"
              ) {
                _this.resetDowloadUrl();
              } else {
                console.log("8888888-msg");
                alert(res.data.body.msg);
                //alert(_this.$t('message.error1'))
              }
            }
          })
          .catch(function (error) {
            _this.timerInerval && clearInterval(_this.timerInerval);
            _this.showBtn.downLoadTimeout = true;
            _this.showBtn.downloadProgress = false;
            _this.showBtn.installProgress = false;
            _this.showBtn.reloadIcon = true;
            console.log(error, "step-wrong");
            _this.downloadProgress = false;
          });
      },
      installProgress() {
        // 安装动画
        this.downProccessOver = false;
        const _this = this;
        this.showBtn.downloadProgress = false;
        this.showBtn.installProgress = true;
        this.timerInerval && clearInterval(this.timerInerval);
        this.installCoutDownTime = 0;
        this.pop.promptAction = true;
        if(this.isIos16){
          this.pop.ios16 = true
        }
      },
      initBtnFail() {
        this.timerInerval && clearInterval(this.timerInerval);
        this.showBtn.downloadProgress = false;
        this.showBtn.installProgress = false;
        this.showBtn.downLoadFail = true;
        this.showBtn.reloadIcon = true;
      },
      resetDowloadUrl() {
        let hasUuid =
          this.$route.query.appCode &&
          (this.$route.query.UDID ||
            localStorage.getItem("udid" || this.getCookie("udid")));
        if (hasUuid) {
          let url = location.href.replace(/[?&]UDID=([^&#]+)/, "");
          localStorage.removeItem("udid");
          this.setCookie(
            "udid",
            this.udid,
            document.domain.split(".").slice(-2).join("."),
            new Date(0)
          );
          location.href = url;
          location.reload();
        }
      },
      reStartDownLoad() {
        // 下载失败后，点击刷新操作
        if (this.showBtn.downLoadFail || this.showBtn.downLoadTimeout) {
          this.showBtn.downLoadFail = false;
          this.showBtn.downLoadTimeout = false;
          this.showBtn.downLoad = true;
          this.installCoutDownTime = 10;
          this.downloadProgressNum = 0;
        }
      },
      getDefaultKey(res) {
        let lanarr = ["en", "cn", "th", "ja", "vi"];
        let hasurllang =
          this.$route.query.appCode &&
          this.$route.query.lang &&
          lanarr.includes(this.$route.query.lang);
        console.log("getdefalt-key");
        if (
          res.data.body.data.app &&
          res.data.body.data.app.default_lang_id &&
          !hasurllang
        ) {
          let lmap = {
            en: 1,
            zh: 0,
            tl: 9,
            jp: 3,
            vn: 10,
          };
          for (let key in lmap) {
            if (lmap[key] === res.data.body.data.app.default_lang_id) {
              console.log(key, this.getLang(), this.getLang() != key, "---key");
              this.lang = key;
              this.$i18n.locale = key;
              if (this.getLang() != key) {
                this.saveLang();
                location.reload();
              }
              console.log(key, "---->get-defalt-key");
            }
          }
        }
      },

      getConfigFileOnline(callback) {
        // 获取在线的配置文件
        const _this = this;
        let data = {};
        let model = this.hasMode || 0;
        axios({
          method: "GET",
          url:
            "/api/sign/app?appCode=" +
            this.appCode +
            "&model=" +
            model +
            "&lang=" +
            this.langId,
          data: {},
        })
          .then(function (res) {
            console.log(
              _this.configFileOnlie,
              res.data.body && res.data.body.data,
              "init-data"
            );
            if (res.data.body.success === 1) {
              _this.configFileOnlie = res.data.body.data.app;
              _this.$store.state.appVersion = _this.configFileOnlie.in_bsvs
              console.log(_this.getLang(), "-----to-see-default-lang2");
              if (
                res.data.body.data &&
                res.data.body.data.app &&
                res.data.body.data.app.default_lang_id &&
                !_this.getLang()
              ) {
                console.log("-----todefalt-lan");
                _this.getDefaultKey(res);
              }
              _this.toOldProgress = res.data.body.data.sign_progress_switch;
              _this.autoStartDownload = !res.data.body.data.app.out_old_install;
              console.log(_this.toOldProgress, " _this.toOldProgress");
              _this.playerOptions.sources[0].src =
                _this.configFileOnlie.out_guide_link;
              _this.playerOptions.poster =
                _this.configFileOnlie.out_guide_pic_link;
              callback && callback(res);
            } else {
              alert(res.data.body.msg);
              //alert(_this.$t('message.error1'))
            }
          })
          .catch(function (error) {
            console.log('页面返回值',error);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @function _vw($n){
    @return 100vw / 375 * $n
  };
  .public-title-version{
    color: #838383;
    margin-top: _vw(-13);
    margin-bottom: _vw(10);
  }
  
  .btn-box{
    /* position: absolute;
    top: 0.266667rem;
    right: 90px; */
    display: flex;
    gap: 5px;
  }
  .brief .brief-des .brief-des-block {
    max-height: none;
  }

  .p-wrap {
    overflow: hidden;
  }

  .more-msg .msg-list-l {
    margin-left: 0;
  }

  .more-msg .msg-list-r {
    margin-left: 0;
    padding-left: 0;
    margin-right: 0;
    padding-right: 0;
  }

  .more-msg .msg-list {
    width: 100%;
    overflow: hidden;
  }

  .randomcode {
    max-width: 5.33rem;
    display: inline-block;
    font-size: 0.26rem;
  }
  .pop-title{
    text-align: center;
    margin: 0px 0px 13px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue